import { Button, Space } from "antd";
import { ColumnsType } from "antd/es/table";
import { useCallback, useEffect, useState } from "react";
import { addKeyInArray } from "../../../helpers/siteConfig";
import useTable from "../../../hooks/useTable";
import {
  getAllPaymentAsync,
  getCountPaymentAsync,
  getFinanceBalanceAsync,
  updateStatusAsync,
} from "../../../store/features/NP/payment/paymentAPI";
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from "../../../store/store";
// import { NetworkTableColumn } from "../../../types";
import { BASE_API } from "../../../helpers/apiUrl";
import { API_URL } from "../../../helpers/config";
import { toast } from "../../../helpers/toast";
import useModal from "../../../hooks/useModal";
import { GetAllPaymentParams } from "../../../types/redux";
import { capitalize } from "../../../utils/string";
import ConfirmModal from "../../common/ConfirmModal";
import CustomTable from "../../common/CustomTable";

import EyeIcon from "../../../assets/icons/EyeIcon";
import AXIOS from "../../../helpers/api";
import ViewPaymentModal from "./ViewPaymentModal";

interface PaymentTableProps {
  date: { from: string; to: string };
  status?: string;
  checked: "all" | "no";
}

// interface GetAllPaymentData {
//   pg: {
//     firstName: string;
//     lastName: string;
//   };
//   regionName: string;
//   areaName: string;
//   teritoryName: string;
//   minutesOfWork: number;
//   paid: boolean;

// }

interface NetworkTableColumn {
  _id: string;
  siteCode: string;
  towerName: string;
  pg: {
    firstName: string;
    lastName: string;
  };
  regionName: string;
  areaName: string;
  teritoryName: string;
  minutesOfWork: number;
  paid: boolean;
  regionCheck?: boolean;
  superAdminCheck?: boolean;
  totalAmount?: number;
  missCall?: boolean;
  // other properties
}

export default function PaymentTable({
  date,
  checked,
  status,
}: PaymentTableProps) {
  const [paidLoading, setPaidLoading] = useState(false);
  const { open, handleOpen, toggle } = useModal(reRender);
  const dispatch = useAppDispatch();
  const { limit, page, handlePagination } = useTable();
  const { login, token } = useAppSelector((state) => state.login);

  const { allPayment, paymentCount, loading } = useAppSelector(
    (state: RootState) => state.payment
  );

  const [tableData, setTableData] = useState<NetworkTableColumn[] | undefined>(
    undefined
  );

  const handleUpdate = (id: string, role?: "region" | "superAdmin") => {
    dispatch(
      updateStatusAsync({
        others: {
          id,
          params: {
            role,
          },
          reRender,
        },
      })
    );
  };

  // console.log(login?.role);

  const columns: ColumnsType<NetworkTableColumn> = [
    // {
    //   title: "Ticket",
    //   dataIndex: "towerTicketId",
    //   align: "center",
    // },

    {
      title: "Site Locator Name",
      render: (val) => (
        <Space className="table_column_title" size={0} direction="vertical">
          <h5>{val?.siteCode}</h5>
          <p>Tower name: {capitalize(val?.towerName)}</p>
        </Space>
      ),
    },

    {
      title: "PG Name",
      dataIndex: "pg",
      align: "center",
      render: (val) => `${val?.firstName} ${val?.lastName}`,
    },
    {
      title: "Cluster",
      dataIndex: "regionName",
      align: "center",
    },
    {
      title: "Zone",
      dataIndex: "areaName",
      align: "center",
    },
    {
      title: "Territory",
      dataIndex: "teritoryName",
      align: "center",
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      align: "center",
    },
    {
      title: "Miss Call",
      dataIndex: "missCall",
      align: "center",
      render: (val) => (val ? "Yes" : "No"),
    },
    {
      title: "Working Hours (minutes)",
      dataIndex: "totalValidRunTime",
      align: "center",
      render: (val) => Math.round(val || 0) + " minutes",
    },

    {
      title: "Action",
      align: "center",
      dataIndex: "paid",
      render: (_, record: NetworkTableColumn) => {
        const viewButton = (
          <Button
            className="ml-4"
            icon={<EyeIcon />}
            onClick={() =>
              handleOpen({
                type: "VIEW",
                data: record,
              })
            }
          />
        );

        if (record.paid) {
          return (
            <>
              <Button
                size="small"
                type="primary"
                className="!cursor-default"
                disabled
              >
                Paid
              </Button>
              {viewButton}
            </>
          );
        }

        if (login?.role === "region") {
          if (!record.paid && !record?.regionCheck) {
            return (
              <>
                <Button
                  size="small"
                  type="primary"
                  onClick={() => handleUpdate(record?._id, "region")}
                >
                  Send To Admin
                </Button>
                {/* {viewButton} */}
              </>
            );
          } else if (!record.paid && record?.regionCheck) {
            return (
              <>
                <Button
                  size="small"
                  type="primary"
                  className="!cursor-default"
                  disabled
                >
                  Already Sent
                </Button>
                {/* {viewButton} */}
              </>
            );
          }
        }

        if (login?.role === "edatco") {
          if (!record?.paid && !record?.superAdminCheck) {
            return (
              <>
                <Button
                  size="small"
                  type="primary"
                  // onClick={() => handleUpdate(record?._id, "superAdmin")}
                  onClick={() => handleOpen({ type: "FINANCE", data: record })}
                >
                  Send To Finance
                </Button>
                {/* {viewButton} */}
              </>
            );
          } else if (!record?.paid && record?.superAdminCheck) {
            return (
              <>
                <Button
                  size="small"
                  type="primary"
                  className="!cursor-default"
                  disabled
                >
                  Pending For Payment
                </Button>
                {/* {viewButton} */}
              </>
            );
          }
        }

        if (login?.role === "finance") {
          return (
            <>
              <Button
                size="small"
                type="default"
                className="!bg-gray-400 !text-white !cursor-pointer"
                onClick={() => handleOpen({ type: "UNPAID", data: record })}
              >
                Unpaid
              </Button>
              {/* {viewButton} */}
            </>
          );
        }

        // In case no condition matches, still show the view button
        // return <>{viewButton}</>;
      },
    },
  ];

  const paymentData = useCallback(() => {
    const roles = {
      edatco: "admin",
      region: "region",
      finance: "finance",
    } as const;

    const params: GetAllPaymentParams = {
      limit: limit,
      skip: limit * (page - 1),
      role:
        checked === "no" && login?.role
          ? roles[login?.role as keyof typeof roles]
          : "all",
    };

    if (status) {
      params.paid = status;
    }

    if (date?.to && date?.from) {
      params.startDate = date?.to;
      params.endDate = date?.from;
    }

    if (login?.role === "region" || login?.role === "finance") {
      params.region = login?.region;
    }

    dispatch(
      getAllPaymentAsync({
        params,
      })
    );

    dispatch(
      getCountPaymentAsync({
        params,
      })
    );
  }, [
    checked,
    date?.from,
    date?.to,
    dispatch,
    limit,
    login?.region,
    login?.role,
    page,
    status,
  ]);

  function reRender(val?: boolean) {
    if (val) {
      paymentData();
      toggle();
    }
  }

  const handleUnpaidClick = async (id: string) => {
    setPaidLoading(true);
    const apiUrl = `${API_URL}${BASE_API.getUnpaidClick}/${id}`;
    try {
      const response = await AXIOS.get(apiUrl, {
        // headers: {
        //   Authorization: `Bearer ${token}`,
        // },
      });

      // console.log("Responsse Data", response);

      setTableData((prevData = []) => {
        return prevData.map((item) =>
          item._id === response?.data?.data?._id
            ? { ...item, response: response?.data?.data?.response, paid: true }
            : item
        );
      });
      // console.log("Table Data", tableData);

      toggle(true);
      // if (response?.data?.data?.issuccess === true) {
      //   toast("success", "Successfully Paid");
      // } else {
      //   toast("error", `${response?.data?.data?.message}`);
      // }
      dispatch(getFinanceBalanceAsync(token));
      toast("success", "Successfully Paid");

      setPaidLoading(false);
    } catch (error: any) {
      toast("error", error?.response?.data?.data?.message || "Payment Failed");
      setPaidLoading(false);
    }
  };

  useEffect(() => {
    paymentData();
  }, [paymentData]);

  useEffect(() => {
    if (allPayment) {
      const transformedData: NetworkTableColumn[] = allPayment.map(
        (payment: any) => ({
          _id: payment._id || "default-id",
          siteCode: payment.siteCode || "default-site-code",
          towerName: payment.towerName || "default-tower-name",
          pg: payment.pg,
          regionName: payment.regionName,
          areaName: payment.areaName,
          teritoryName: payment.teritoryName,
          minutesOfWork: payment.minutesOfWork,
          paid: payment.paid,
          superAdminCheck: payment.superAdminCheck,
          regionCheck: payment.regionCheck,
          totalValidRunTime: payment.totalValidRunTime,
          response: payment.response,
          totalAmount: payment.totalAmount,
          missCall: payment.missCall,
        })
      );

      setTableData(transformedData);
    }
  }, [allPayment]);

  return (
    <>
      {open?.type === "UNPAID" && (
        <ConfirmModal
          deleteTitle="Paid Payment"
          questionText="Are you sure you want to payment?"
          handleClose={toggle}
          data={open?.data._id}
          deleteLoading={paidLoading}
          handleYes={() => handleUnpaidClick(open?.data._id)}
          open={open?.open}
          title={""}
        >
          <p className="ml-10 font-semibold mt-4">
            Tower Name: {capitalize(open?.data?.towerName)}
          </p>
          <p className="ml-10 font-semibold">
            Total Amount: {open?.data?.totalAmount}
          </p>
        </ConfirmModal>
      )}

      {open?.type === "FINANCE" && (
        <ConfirmModal
          deleteTitle="Sent to Finance"
          questionText="Are you sure you want to send finance?"
          handleClose={toggle}
          data={open?.data._id}
          deleteLoading={paidLoading}
          handleYes={() => handleUpdate(open?.data?._id, "superAdmin")}
          open={open?.open}
          title={""}
        ></ConfirmModal>
      )}

      {open.type === "VIEW" && (
        <ViewPaymentModal
          open={open.open}
          data={open.data}
          handleClose={toggle}
        />
      )}

      <CustomTable<NetworkTableColumn>
        loading={loading}
        total={paymentCount}
        page={page}
        handlePagination={handlePagination}
        columns={columns}
        // dataList={addKeyInArray(allPayment)}
        dataList={tableData ? addKeyInArray(tableData) : []}
      />
    </>
  );
}
